import config from './config'

export type FeatureName = keyof typeof config.features

export const isFeatureEnabled = (feature?: FeatureName) =>
  !feature || config.features[feature] !== false
